exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-button-overlay-canvas[data-v-27e92f60],.product-button-overlay__container[data-v-27e92f60]{position:absolute;top:0;left:0;width:100%;height:100%}.product-button-overlay__container[data-v-27e92f60]{z-index:-1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27e92f60","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/bhf-filter/product-button-gradient.vue
// module id = Cfk2
// module chunks = 2